import http from './api'

const url = '/admin_data/frontpage'

export const httpGetFrontpageInfo = () => {
  return http({
    url: `${url}/`,
    method: 'GET',
  })
}